// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"AVV7IddIkGtW9CZtRSUZ","icon":"qcSkmj76l4iSZet5zvpg","text":"kaK2j16cZ6LdLGWYwaWY"};